import { useEffect, useState } from "react";

function AllowCustomerPlanSwitch(props) {
  const [isChecked, setIsChecked] = useState(false);

  useEffect(() => {
    if (props.defaultVal === 1) {
      setIsChecked(true);
    }
  }, [props.defaultVal]);

  const onCheckAction = (check) => {
    setIsChecked(check);
    props.allowPlanSwitch(check);
  };

  return (
    <>
      <div className="mt-2 text-sm">
        <div className="flex items-center">
          <input
            checked={isChecked}
            onChange={(e) => onCheckAction(e.target.checked)}
            type="checkbox"
            className="w-4 h-4 z-10 rounded-sm checked:ring-0 focus:ring-0 cursor-pointer"
            value="2"
          />
          <span className="text-xs font-medium ml-2">
            Allow customers switch their existing plan to this plan, from the
            customer portal
          </span>
        </div>
      </div>
    </>
  );
}

export default AllowCustomerPlanSwitch;
